// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./styles/stitch-tokens.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, system-ui, Segoe UI, Tahoma, Geneva, Verdana, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

input:where([type='text']),input:where(:not([type])),input:where([type='email']),input:where([type='url']),input:where([type='password']),input:where([type='number']),input:where([type='date']),input:where([type='datetime-local']),input:where([type='month']),input:where([type='search']),input:where([type='tel']),input:where([type='time']),input:where([type='week']),select:where([multiple]),textarea,select{
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

input:where([type='text']):focus, input:where(:not([type])):focus, input:where([type='email']):focus, input:where([type='url']):focus, input:where([type='password']):focus, input:where([type='number']):focus, input:where([type='date']):focus, input:where([type='datetime-local']):focus, input:where([type='month']):focus, input:where([type='search']):focus, input:where([type='tel']):focus, input:where([type='time']):focus, input:where([type='week']):focus, select:where([multiple]):focus, textarea:focus, select:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::placeholder,textarea::placeholder{
  color: #6b7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper{
  padding: 0;
}

::-webkit-date-and-time-value{
  min-height: 1.5em;
  text-align: inherit;
}

::-webkit-datetime-edit{
  display: inline-flex;
}

::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{
  padding-top: 0;
  padding-bottom: 0;
}

select{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

select:where([multiple]),select:where([size]:not([size="1"])){
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: unset;
          print-color-adjust: unset;
}

input:where([type='checkbox']),input:where([type='radio']){
  -webkit-appearance: none;
          appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

input:where([type='checkbox']){
  border-radius: 0px;
}

input:where([type='radio']){
  border-radius: 100%;
}

input:where([type='checkbox']):focus,input:where([type='radio']):focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

input:where([type='checkbox']):checked,input:where([type='radio']):checked{
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

input:where([type='checkbox']):checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@media (forced-colors: active) {

  input:where([type='checkbox']):checked{
    -webkit-appearance: auto;
            appearance: auto;
  }
}

input:where([type='radio']):checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media (forced-colors: active) {

  input:where([type='radio']):checked{
    -webkit-appearance: auto;
            appearance: auto;
  }
}

input:where([type='checkbox']):checked:hover,input:where([type='checkbox']):checked:focus,input:where([type='radio']):checked:hover,input:where([type='radio']):checked:focus{
  border-color: transparent;
  background-color: currentColor;
}

input:where([type='checkbox']):indeterminate{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media (forced-colors: active) {

  input:where([type='checkbox']):indeterminate{
    -webkit-appearance: auto;
            appearance: auto;
  }
}

input:where([type='checkbox']):indeterminate:hover,input:where([type='checkbox']):indeterminate:focus{
  border-color: transparent;
  background-color: currentColor;
}

input:where([type='file']){
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

input:where([type='file']):focus{
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}

/* Basic resets for consistent rendering */

*,
  *::before,
  *::after {
    box-sizing: border-box;
  }

body {
    margin: 0;
    font-family: Inter, system-ui, 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    line-height: 1.5;
    --tw-bg-opacity: 1;
    background-color: rgb(var(--stitch-canvas) / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(var(--stitch-fg) / var(--tw-text-opacity, 1));
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

/*
   * Mobile overflow safety net. On real phones (e.g. Galaxy S23 @ 360px) any single
   * stray-wide descendant — a decorative blur blob, a long unbreakable string — makes
   * <body> wider than the viewport, which shifts the whole page right (logo padding
   * scrolls off, right edge gets cut). \`clip\` stops that horizontal shift without
   * turning <body> into a scroll container, so \`position: sticky\` on the header keeps
   * working. This is a guard, not a licence to ship genuinely-wide content.
   */

html,
  body {
    max-width: 100%;
    overflow-x: clip;
  }

/*
   * Safety net: @tailwindcss/forms defaults raw inputs to white backgrounds.
   * Without this, dark mode shows invisible text on white fields.
   */

html.dark input[type='text'],
  html.dark input[type='email'],
  html.dark input[type='password'],
  html.dark input[type='search'],
  html.dark input[type='tel'],
  html.dark input[type='url'],
  html.dark input[type='number'],
  html.dark input[type='date'],
  html.dark input[type='time'],
  html.dark input[type='datetime-local'],
  html.dark input[type='month'],
  html.dark input[type='week'],
  html.dark textarea,
  html.dark select{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-border) / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-surface) / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-fg) / var(--tw-text-opacity, 1));
}

html.dark input[type='text']::placeholder,
  html.dark input[type='email']::placeholder,
  html.dark input[type='password']::placeholder,
  html.dark input[type='search']::placeholder,
  html.dark input[type='tel']::placeholder,
  html.dark input[type='url']::placeholder,
  html.dark input[type='number']::placeholder,
  html.dark input[type='date']::placeholder,
  html.dark input[type='time']::placeholder,
  html.dark input[type='datetime-local']::placeholder,
  html.dark input[type='month']::placeholder,
  html.dark input[type='week']::placeholder,
  html.dark textarea::placeholder,
  html.dark select::placeholder{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-muted) / var(--tw-text-opacity, 1));
}

html.dark select option{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-surface) / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-fg) / var(--tw-text-opacity, 1));
}

.material-symbols-outlined {
    font-family: 'Material Symbols Outlined';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    font-feature-settings: 'liga';
    -webkit-font-feature-settings: 'liga';
    -moz-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
    text-rendering: optimizeLegibility;
    vertical-align: middle;
  }
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.prose{
  color: var(--tw-prose-body);
  max-width: 65ch;
}
.prose :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-lead);
  font-size: 1.25em;
  line-height: 1.6;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}
.prose :where(a):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-links);
  text-decoration: underline;
  font-weight: 500;
}
.prose :where(strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-bold);
  font-weight: 600;
}
.prose :where(a strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(blockquote strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(thead th strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: decimal;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
  -webkit-padding-start: 1.625em;
          padding-inline-start: 1.625em;
}
.prose :where(ol[type="A"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: upper-alpha;
}
.prose :where(ol[type="a"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: lower-alpha;
}
.prose :where(ol[type="A" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: upper-alpha;
}
.prose :where(ol[type="a" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: lower-alpha;
}
.prose :where(ol[type="I"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: upper-roman;
}
.prose :where(ol[type="i"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: lower-roman;
}
.prose :where(ol[type="I" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: upper-roman;
}
.prose :where(ol[type="i" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: lower-roman;
}
.prose :where(ol[type="1"]):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: decimal;
}
.prose :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  list-style-type: disc;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
  -webkit-padding-start: 1.625em;
          padding-inline-start: 1.625em;
}
.prose :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *))::marker{
  font-weight: 400;
  color: var(--tw-prose-counters);
}
.prose :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *))::marker{
  color: var(--tw-prose-bullets);
}
.prose :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.25em;
}
.prose :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  border-color: var(--tw-prose-hr);
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}
.prose :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-weight: 500;
  font-style: italic;
  color: var(--tw-prose-quotes);
  border-inline-start-width: 0.25rem;
  border-inline-start-color: var(--tw-prose-quote-borders);
  quotes: "\\201C""\\201D""\\2018""\\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  -webkit-padding-start: 1em;
          padding-inline-start: 1em;
}
.prose :where(blockquote p:first-of-type):not(:where([class~="not-prose"],[class~="not-prose"] *))::before{
  content: open-quote;
}
.prose :where(blockquote p:last-of-type):not(:where([class~="not-prose"],[class~="not-prose"] *))::after{
  content: close-quote;
}
.prose :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-headings);
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}
.prose :where(h1 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-weight: 900;
  color: inherit;
}
.prose :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-headings);
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}
.prose :where(h2 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-weight: 800;
  color: inherit;
}
.prose :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-headings);
  font-weight: 600;
  font-size: 1.25em;
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}
.prose :where(h3 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-weight: 700;
  color: inherit;
}
.prose :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}
.prose :where(h4 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-weight: 700;
  color: inherit;
}
.prose :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  display: block;
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  font-weight: 500;
  font-family: inherit;
  color: var(--tw-prose-kbd);
  box-shadow: 0 0 0 1px var(--tw-prose-kbd-shadows), 0 3px 0 var(--tw-prose-kbd-shadows);
  font-size: 0.875em;
  border-radius: 0.3125rem;
  padding-top: 0.1875em;
  -webkit-padding-end: 0.375em;
          padding-inline-end: 0.375em;
  padding-bottom: 0.1875em;
  -webkit-padding-start: 0.375em;
          padding-inline-start: 0.375em;
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-code);
  font-weight: 600;
  font-size: 0.875em;
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))::before{
  content: "\`";
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))::after{
  content: "\`";
}
.prose :where(a code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(h1 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
  font-size: 0.875em;
}
.prose :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
  font-size: 0.9em;
}
.prose :where(h4 code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(blockquote code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(thead th code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: inherit;
}
.prose :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-pre-code);
  background-color: var(--tw-prose-pre-bg);
  overflow-x: auto;
  font-weight: 400;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding-top: 0.8571429em;
  -webkit-padding-end: 1.1428571em;
          padding-inline-end: 1.1428571em;
  padding-bottom: 0.8571429em;
  -webkit-padding-start: 1.1428571em;
          padding-inline-start: 1.1428571em;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: inherit;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *))::before{
  content: none;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *))::after{
  content: none;
}
.prose :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  width: 100%;
  table-layout: auto;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}
.prose :where(thead):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-th-borders);
}
.prose :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-headings);
  font-weight: 600;
  vertical-align: bottom;
  -webkit-padding-end: 0.5714286em;
          padding-inline-end: 0.5714286em;
  padding-bottom: 0.5714286em;
  -webkit-padding-start: 0.5714286em;
          padding-inline-start: 0.5714286em;
}
.prose :where(tbody tr):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-td-borders);
}
.prose :where(tbody tr:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  border-bottom-width: 0;
}
.prose :where(tbody td):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  vertical-align: baseline;
}
.prose :where(tfoot):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  border-top-width: 1px;
  border-top-color: var(--tw-prose-th-borders);
}
.prose :where(tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  vertical-align: top;
}
.prose :where(th, td):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  text-align: start;
}
.prose :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
  margin-bottom: 0;
}
.prose :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  color: var(--tw-prose-captions);
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}
.prose{
  --tw-prose-body: #374151;
  --tw-prose-headings: #111827;
  --tw-prose-lead: #4b5563;
  --tw-prose-links: #111827;
  --tw-prose-bold: #111827;
  --tw-prose-counters: #6b7280;
  --tw-prose-bullets: #d1d5db;
  --tw-prose-hr: #e5e7eb;
  --tw-prose-quotes: #111827;
  --tw-prose-quote-borders: #e5e7eb;
  --tw-prose-captions: #6b7280;
  --tw-prose-kbd: #111827;
  --tw-prose-kbd-shadows: rgb(17 24 39 / 10%);
  --tw-prose-code: #111827;
  --tw-prose-pre-code: #e5e7eb;
  --tw-prose-pre-bg: #1f2937;
  --tw-prose-th-borders: #d1d5db;
  --tw-prose-td-borders: #e5e7eb;
  --tw-prose-invert-body: #d1d5db;
  --tw-prose-invert-headings: #fff;
  --tw-prose-invert-lead: #9ca3af;
  --tw-prose-invert-links: #fff;
  --tw-prose-invert-bold: #fff;
  --tw-prose-invert-counters: #9ca3af;
  --tw-prose-invert-bullets: #4b5563;
  --tw-prose-invert-hr: #374151;
  --tw-prose-invert-quotes: #f3f4f6;
  --tw-prose-invert-quote-borders: #374151;
  --tw-prose-invert-captions: #9ca3af;
  --tw-prose-invert-kbd: #fff;
  --tw-prose-invert-kbd-shadows: rgb(255 255 255 / 10%);
  --tw-prose-invert-code: #fff;
  --tw-prose-invert-pre-code: #d1d5db;
  --tw-prose-invert-pre-bg: rgb(0 0 0 / 50%);
  --tw-prose-invert-th-borders: #4b5563;
  --tw-prose-invert-td-borders: #374151;
  font-size: 1rem;
  line-height: 1.75;
}
.prose :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
  margin-bottom: 0;
}
.prose :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
.prose :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  -webkit-padding-start: 0.375em;
          padding-inline-start: 0.375em;
}
.prose :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  -webkit-padding-start: 0.375em;
          padding-inline-start: 0.375em;
}
.prose :where(.prose > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose :where(.prose > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.25em;
}
.prose :where(.prose > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-bottom: 1.25em;
}
.prose :where(.prose > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.25em;
}
.prose :where(.prose > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-bottom: 1.25em;
}
.prose :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0.5em;
  -webkit-padding-start: 1.625em;
          padding-inline-start: 1.625em;
}
.prose :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  -webkit-padding-start: 0;
          padding-inline-start: 0;
}
.prose :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  -webkit-padding-end: 0;
          padding-inline-end: 0;
}
.prose :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  padding-top: 0.5714286em;
  -webkit-padding-end: 0.5714286em;
          padding-inline-end: 0.5714286em;
  padding-bottom: 0.5714286em;
  -webkit-padding-start: 0.5714286em;
          padding-inline-start: 0.5714286em;
}
.prose :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  -webkit-padding-start: 0;
          padding-inline-start: 0;
}
.prose :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  -webkit-padding-end: 0;
          padding-inline-end: 0;
}
.prose :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(.prose > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-top: 0;
}
.prose :where(.prose > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)){
  margin-bottom: 0;
}
.prose-blue{
  --tw-prose-links: #2563eb;
  --tw-prose-invert-links: #3b82f6;
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: -webkit-sticky;
  position: sticky;
}
.-inset-5{
  inset: -1.25rem;
}
.inset-0{
  inset: 0px;
}
.-inset-y-4{
  top: -1rem;
  bottom: -1rem;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-bottom-20{
  bottom: -5rem;
}
.-bottom-24{
  bottom: -6rem;
}
.-bottom-5{
  bottom: -1.25rem;
}
.-left-12{
  left: -3rem;
}
.-left-16{
  left: -4rem;
}
.-left-5{
  left: -1.25rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-10{
  right: -2.5rem;
}
.-right-12{
  right: -3rem;
}
.-right-16{
  right: -4rem;
}
.-right-20{
  right: -5rem;
}
.-top-10{
  top: -2.5rem;
}
.-top-12{
  top: -3rem;
}
.-top-16{
  top: -4rem;
}
.-top-20{
  top: -5rem;
}
.-top-24{
  top: -6rem;
}
.-top-40{
  top: -10rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-10{
  bottom: 2.5rem;
}
.bottom-4{
  bottom: 1rem;
}
.left-0{
  left: 0px;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-6{
  left: 1.5rem;
}
.left-8{
  left: 2rem;
}
.left-\\[-15\\%\\]{
  left: -15%;
}
.right-0{
  right: 0px;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-8{
  right: 2rem;
}
.right-\\[-10\\%\\]{
  right: -10%;
}
.top-0{
  top: 0px;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-24{
  top: 6rem;
}
.top-3{
  top: 0.75rem;
}
.top-32{
  top: 8rem;
}
.top-4{
  top: 1rem;
}
.-z-10{
  z-index: -10;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-12{
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.-mr-\\[3px\\]{
  margin-right: -3px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-14{
  margin-bottom: 3.5rem;
}
.mb-16{
  margin-bottom: 4rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-9{
  margin-bottom: 2.25rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-auto{
  margin-left: auto;
}
.ml-px{
  margin-left: 1px;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-56{
  height: 14rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[1\\.1em\\]{
  height: 1.1em;
}
.h-\\[1\\.625em\\]{
  height: 1.625em;
}
.h-\\[34rem\\]{
  height: 34rem;
}
.h-\\[40rem\\]{
  height: 40rem;
}
.h-\\[calc\\(100dvh-7rem\\)\\]{
  height: calc(100dvh - 7rem);
}
.h-\\[min\\(92dvh\\2c calc\\(100dvh-8rem\\)\\)\\]{
  height: min(92dvh,calc(100dvh - 8rem));
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.max-h-32{
  max-height: 8rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[95vh\\]{
  max-height: 95vh;
}
.max-h-\\[calc\\(100vh-8rem\\)\\]{
  max-height: calc(100vh - 8rem);
}
.min-h-0{
  min-height: 0px;
}
.min-h-96{
  min-height: 24rem;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[250px\\]{
  min-height: 250px;
}
.min-h-\\[36px\\]{
  min-height: 36px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[40vh\\]{
  min-height: 40vh;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[520px\\]{
  min-height: 520px;
}
.min-h-\\[90px\\]{
  min-height: 90px;
}
.min-h-\\[calc\\(100dvh-8rem\\)\\]{
  min-height: calc(100dvh - 8rem);
}
.min-h-\\[calc\\(100vh-4rem\\)\\]{
  min-height: calc(100vh - 4rem);
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-0\\.5{
  width: 0.125rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[34rem\\]{
  width: 34rem;
}
.w-\\[3px\\]{
  width: 3px;
}
.w-\\[40rem\\]{
  width: 40rem;
}
.w-full{
  width: 100%;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[44px\\]{
  min-width: 44px;
}
.min-w-full{
  min-width: 100%;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[82\\%\\]{
  max-width: 82%;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1 0%;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.origin-left{
  transform-origin: left;
}
.translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5{
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0\\.5{
  --tw-translate-y: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[2px\\]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-12{
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[20deg\\]{
  --tw-rotate: 20deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping{

  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.scroll-mt-24{
  scroll-margin-top: 6rem;
}
.scroll-mt-28{
  scroll-margin-top: 7rem;
}
.list-inside{
  list-style-position: inside;
}
.list-disc{
  list-style-type: disc;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-rows-2{
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[3px\\]{
  gap: 3px;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-5{
  column-gap: 1.25rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-stitch-border > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(var(--stitch-border) / var(--tw-divide-opacity, 1));
}
.self-start{
  align-self: flex-start;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-clip{
  overflow-x: clip;
}
.overscroll-y-contain{
  overscroll-behavior-y: contain;
}
.scroll-smooth{
  scroll-behavior: smooth;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[2rem\\]{
  border-radius: 2rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-stitch-2xl{
  border-radius: var(--stitch-radius-2xl);
}
.rounded-stitch-lg{
  border-radius: var(--stitch-radius-lg);
}
.rounded-stitch-md{
  border-radius: var(--stitch-radius-md);
}
.rounded-stitch-xl{
  border-radius: var(--stitch-radius-xl);
}
.rounded-l-stitch-lg{
  border-top-left-radius: var(--stitch-radius-lg);
  border-bottom-left-radius: var(--stitch-radius-lg);
}
.rounded-r-stitch-lg{
  border-top-right-radius: var(--stitch-radius-lg);
  border-bottom-right-radius: var(--stitch-radius-lg);
}
.rounded-t-stitch-xl{
  border-top-left-radius: var(--stitch-radius-xl);
  border-top-right-radius: var(--stitch-radius-xl);
}
.rounded-tl-sm{
  border-top-left-radius: 0.125rem;
}
.rounded-tr-sm{
  border-top-right-radius: 0.125rem;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-dashed{
  border-style: dashed;
}
.border-stitch-accent{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-accent) / var(--tw-border-opacity, 1));
}
.border-stitch-accent\\/20{
  border-color: rgb(var(--stitch-accent) / 0.2);
}
.border-stitch-accent\\/40{
  border-color: rgb(var(--stitch-accent) / 0.4);
}
.border-stitch-border{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-border) / var(--tw-border-opacity, 1));
}
.border-stitch-border\\/50{
  border-color: rgb(var(--stitch-border) / 0.5);
}
.border-stitch-danger{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-danger) / var(--tw-border-opacity, 1));
}
.border-stitch-danger\\/30{
  border-color: rgb(var(--stitch-danger) / 0.3);
}
.border-stitch-danger\\/40{
  border-color: rgb(var(--stitch-danger) / 0.4);
}
.border-stitch-danger\\/60{
  border-color: rgb(var(--stitch-danger) / 0.6);
}
.border-stitch-primary{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-primary) / var(--tw-border-opacity, 1));
}
.border-stitch-primary-soft\\/50{
  border-color: rgb(var(--stitch-primary-soft) / 0.5);
}
.border-stitch-primary\\/20{
  border-color: rgb(var(--stitch-primary) / 0.2);
}
.border-stitch-primary\\/30{
  border-color: rgb(var(--stitch-primary) / 0.3);
}
.border-stitch-primary\\/40{
  border-color: rgb(var(--stitch-primary) / 0.4);
}
.border-stitch-success{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-success) / var(--tw-border-opacity, 1));
}
.border-stitch-success\\/30{
  border-color: rgb(var(--stitch-success) / 0.3);
}
.border-stitch-success\\/40{
  border-color: rgb(var(--stitch-success) / 0.4);
}
.border-stitch-surface{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-surface) / var(--tw-border-opacity, 1));
}
.border-stitch-warning-soft{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-warning-soft) / var(--tw-border-opacity, 1));
}
.border-stitch-warning\\/30{
  border-color: rgb(var(--stitch-warning) / 0.3);
}
.border-stitch-warning\\/40{
  border-color: rgb(var(--stitch-warning) / 0.4);
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/90{
  border-color: rgb(255 255 255 / 0.9);
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-stitch-accent{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-accent) / var(--tw-bg-opacity, 1));
}
.bg-stitch-accent-soft{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-accent-soft) / var(--tw-bg-opacity, 1));
}
.bg-stitch-accent-soft\\/80{
  background-color: rgb(var(--stitch-accent-soft) / 0.8);
}
.bg-stitch-accent\\/15{
  background-color: rgb(var(--stitch-accent) / 0.15);
}
.bg-stitch-accent\\/30{
  background-color: rgb(var(--stitch-accent) / 0.3);
}
.bg-stitch-accent\\/40{
  background-color: rgb(var(--stitch-accent) / 0.4);
}
.bg-stitch-border{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-border) / var(--tw-bg-opacity, 1));
}
.bg-stitch-border\\/40{
  background-color: rgb(var(--stitch-border) / 0.4);
}
.bg-stitch-border\\/60{
  background-color: rgb(var(--stitch-border) / 0.6);
}
.bg-stitch-canvas{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-canvas) / var(--tw-bg-opacity, 1));
}
.bg-stitch-danger{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-danger) / var(--tw-bg-opacity, 1));
}
.bg-stitch-danger-soft{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-danger-soft) / var(--tw-bg-opacity, 1));
}
.bg-stitch-danger-soft\\/40{
  background-color: rgb(var(--stitch-danger-soft) / 0.4);
}
.bg-stitch-danger-soft\\/50{
  background-color: rgb(var(--stitch-danger-soft) / 0.5);
}
.bg-stitch-danger\\/70{
  background-color: rgb(var(--stitch-danger) / 0.7);
}
.bg-stitch-footer-bg{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-footer-bg) / var(--tw-bg-opacity, 1));
}
.bg-stitch-info{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-info) / var(--tw-bg-opacity, 1));
}
.bg-stitch-info-soft{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-info-soft) / var(--tw-bg-opacity, 1));
}
.bg-stitch-info-soft\\/40{
  background-color: rgb(var(--stitch-info-soft) / 0.4);
}
.bg-stitch-info-soft\\/50{
  background-color: rgb(var(--stitch-info-soft) / 0.5);
}
.bg-stitch-muted{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-muted) / var(--tw-bg-opacity, 1));
}
.bg-stitch-overlay\\/40{
  background-color: rgb(var(--stitch-overlay) / 0.4);
}
.bg-stitch-overlay\\/45{
  background-color: rgb(var(--stitch-overlay) / 0.45);
}
.bg-stitch-overlay\\/50{
  background-color: rgb(var(--stitch-overlay) / 0.5);
}
.bg-stitch-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-primary) / var(--tw-bg-opacity, 1));
}
.bg-stitch-primary-hover\\/30{
  background-color: rgb(var(--stitch-primary-hover) / 0.3);
}
.bg-stitch-primary-soft{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-primary-soft) / var(--tw-bg-opacity, 1));
}
.bg-stitch-primary-soft\\/50{
  background-color: rgb(var(--stitch-primary-soft) / 0.5);
}
.bg-stitch-primary-soft\\/60{
  background-color: rgb(var(--stitch-primary-soft) / 0.6);
}
.bg-stitch-primary-soft\\/80{
  background-color: rgb(var(--stitch-primary-soft) / 0.8);
}
.bg-stitch-primary\\/10{
  background-color: rgb(var(--stitch-primary) / 0.1);
}
.bg-stitch-primary\\/15{
  background-color: rgb(var(--stitch-primary) / 0.15);
}
.bg-stitch-primary\\/20{
  background-color: rgb(var(--stitch-primary) / 0.2);
}
.bg-stitch-success{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-success) / var(--tw-bg-opacity, 1));
}
.bg-stitch-success-soft{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-success-soft) / var(--tw-bg-opacity, 1));
}
.bg-stitch-success-soft\\/50{
  background-color: rgb(var(--stitch-success-soft) / 0.5);
}
.bg-stitch-success-soft\\/60{
  background-color: rgb(var(--stitch-success-soft) / 0.6);
}
.bg-stitch-success\\/20{
  background-color: rgb(var(--stitch-success) / 0.2);
}
.bg-stitch-success\\/70{
  background-color: rgb(var(--stitch-success) / 0.7);
}
.bg-stitch-surface{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-surface) / var(--tw-bg-opacity, 1));
}
.bg-stitch-surface-2{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-surface-2) / var(--tw-bg-opacity, 1));
}
.bg-stitch-surface-2\\/60{
  background-color: rgb(var(--stitch-surface-2) / 0.6);
}
.bg-stitch-surface-2\\/80{
  background-color: rgb(var(--stitch-surface-2) / 0.8);
}
.bg-stitch-surface\\/95{
  background-color: rgb(var(--stitch-surface) / 0.95);
}
.bg-stitch-warning{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-warning) / var(--tw-bg-opacity, 1));
}
.bg-stitch-warning-soft{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-warning-soft) / var(--tw-bg-opacity, 1));
}
.bg-stitch-warning-soft\\/40{
  background-color: rgb(var(--stitch-warning-soft) / 0.4);
}
.bg-stitch-warning-soft\\/50{
  background-color: rgb(var(--stitch-warning-soft) / 0.5);
}
.bg-stitch-warning-soft\\/60{
  background-color: rgb(var(--stitch-warning-soft) / 0.6);
}
.bg-stitch-warning\\/70{
  background-color: rgb(var(--stitch-warning) / 0.7);
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-\\[radial-gradient\\(circle_at_50\\%_50\\%\\2c rgb\\(var\\(--stitch-primary\\)\\)_0\\%\\2c transparent_50\\%\\)\\]{
  background-image: radial-gradient(circle at 50% 50%,rgb(var(--stitch-primary)) 0%,transparent 50%);
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-tr{
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-stitch-accent-soft{
  --tw-gradient-from: rgb(var(--stitch-accent-soft) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--stitch-accent-soft) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-stitch-accent\\/25{
  --tw-gradient-from: rgb(var(--stitch-accent) / 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--stitch-accent) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-stitch-canvas{
  --tw-gradient-from: rgb(var(--stitch-canvas) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--stitch-canvas) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-stitch-primary{
  --tw-gradient-from: rgb(var(--stitch-primary) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--stitch-primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-stitch-primary-soft{
  --tw-gradient-from: rgb(var(--stitch-primary-soft) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--stitch-primary-soft) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-stitch-primary-soft\\/40{
  --tw-gradient-from: rgb(var(--stitch-primary-soft) / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--stitch-primary-soft) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-stitch-primary\\/25{
  --tw-gradient-from: rgb(var(--stitch-primary) / 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--stitch-primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-stitch-success-soft{
  --tw-gradient-from: rgb(var(--stitch-success-soft) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--stitch-success-soft) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-stitch-surface{
  --tw-gradient-from: rgb(var(--stitch-surface) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--stitch-surface) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-stitch-warning{
  --tw-gradient-from: rgb(var(--stitch-warning) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--stitch-warning) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-stitch-accent{
  --tw-gradient-to: rgb(var(--stitch-accent) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--stitch-accent) / 1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-stitch-accent\\/10{
  --tw-gradient-to: rgb(var(--stitch-accent) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--stitch-accent) / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-stitch-canvas{
  --tw-gradient-to: rgb(var(--stitch-canvas) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--stitch-canvas) / 1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-stitch-primary-hover{
  --tw-gradient-to: rgb(var(--stitch-primary-hover) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--stitch-primary-hover) / 1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-stitch-primary-soft\\/30{
  --tw-gradient-to: rgb(var(--stitch-primary-soft) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--stitch-primary-soft) / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-stitch-primary\\/10{
  --tw-gradient-to: rgb(var(--stitch-primary) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--stitch-primary) / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-stitch-surface{
  --tw-gradient-to: rgb(var(--stitch-surface) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--stitch-surface) / 1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/\\[0\\.07\\]{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.07) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-stitch-accent{
  --tw-gradient-to: rgb(var(--stitch-accent) / 1) var(--tw-gradient-to-position);
}
.to-stitch-accent-hover{
  --tw-gradient-to: rgb(var(--stitch-accent-hover) / 1) var(--tw-gradient-to-position);
}
.to-stitch-accent-soft{
  --tw-gradient-to: rgb(var(--stitch-accent-soft) / 1) var(--tw-gradient-to-position);
}
.to-stitch-accent-soft\\/25{
  --tw-gradient-to: rgb(var(--stitch-accent-soft) / 0.25) var(--tw-gradient-to-position);
}
.to-stitch-accent-soft\\/30{
  --tw-gradient-to: rgb(var(--stitch-accent-soft) / 0.3) var(--tw-gradient-to-position);
}
.to-stitch-primary-soft{
  --tw-gradient-to: rgb(var(--stitch-primary-soft) / 1) var(--tw-gradient-to-position);
}
.to-stitch-primary-soft\\/40{
  --tw-gradient-to: rgb(var(--stitch-primary-soft) / 0.4) var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-clip-text{
  -webkit-background-clip: text;
          background-clip: text;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.\\!p-2\\.5{
  padding: 0.625rem !important;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.\\!px-2{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-20{
  padding-bottom: 5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-12{
  padding-top: 3rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-20{
  padding-top: 5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-7xl{
  font-size: 4.5rem;
  line-height: 1;
}
.text-\\[1\\.125rem\\]{
  font-size: 1.125rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-6{
  line-height: 1.5rem;
}
.leading-\\[1\\.05\\]{
  line-height: 1.05;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.3em\\]{
  letter-spacing: 0.3em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-tighter{
  letter-spacing: -0.05em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.\\!text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-stitch-accent{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-accent) / var(--tw-text-opacity, 1));
}
.text-stitch-accent-soft\\/90{
  color: rgb(var(--stitch-accent-soft) / 0.9);
}
.text-stitch-border{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-border) / var(--tw-text-opacity, 1));
}
.text-stitch-danger{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-danger) / var(--tw-text-opacity, 1));
}
.text-stitch-fg{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-fg) / var(--tw-text-opacity, 1));
}
.text-stitch-fg-soft{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-fg-soft) / var(--tw-text-opacity, 1));
}
.text-stitch-fg-subtle{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-fg-subtle) / var(--tw-text-opacity, 1));
}
.text-stitch-footer-fg{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-footer-fg) / var(--tw-text-opacity, 1));
}
.text-stitch-footer-fg\\/90{
  color: rgb(var(--stitch-footer-fg) / 0.9);
}
.text-stitch-footer-muted{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-footer-muted) / var(--tw-text-opacity, 1));
}
.text-stitch-footer-muted\\/80{
  color: rgb(var(--stitch-footer-muted) / 0.8);
}
.text-stitch-info{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-info) / var(--tw-text-opacity, 1));
}
.text-stitch-muted{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-muted) / var(--tw-text-opacity, 1));
}
.text-stitch-primary{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-primary) / var(--tw-text-opacity, 1));
}
.text-stitch-primary-soft{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-primary-soft) / var(--tw-text-opacity, 1));
}
.text-stitch-primary-soft\\/95{
  color: rgb(var(--stitch-primary-soft) / 0.95);
}
.text-stitch-primary\\/20{
  color: rgb(var(--stitch-primary) / 0.2);
}
.text-stitch-success{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-success) / var(--tw-text-opacity, 1));
}
.text-stitch-success-soft{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-success-soft) / var(--tw-text-opacity, 1));
}
.text-stitch-surface\\/75{
  color: rgb(var(--stitch-surface) / 0.75);
}
.text-stitch-surface\\/80{
  color: rgb(var(--stitch-surface) / 0.8);
}
.text-stitch-surface\\/85{
  color: rgb(var(--stitch-surface) / 0.85);
}
.text-stitch-surface\\/90{
  color: rgb(var(--stitch-surface) / 0.9);
}
.text-stitch-warning{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-warning) / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.underline{
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}
.decoration-stitch-footer-muted{
  -webkit-text-decoration-color: rgb(var(--stitch-footer-muted) / 1);
          text-decoration-color: rgb(var(--stitch-footer-muted) / 1);
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-90{
  opacity: 0.9;
}
.opacity-\\[0\\.04\\]{
  opacity: 0.04;
}
.opacity-\\[0\\.07\\]{
  opacity: 0.07;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-stitch-card{
  --tw-shadow: var(--stitch-shadow-card);
  --tw-shadow-colored: var(--stitch-shadow-card);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-stitch-modal{
  --tw-shadow: var(--stitch-shadow-modal);
  --tw-shadow-colored: var(--stitch-shadow-modal);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-stitch-pop{
  --tw-shadow: var(--stitch-shadow-pop);
  --tw-shadow-colored: var(--stitch-shadow-pop);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-stitch-primary\\/20{
  --tw-shadow-color: rgb(var(--stitch-primary) / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-stitch-primary\\/25{
  --tw-shadow-color: rgb(var(--stitch-primary) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.ring-stitch-border{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--stitch-border) / var(--tw-ring-opacity, 1));
}
.ring-stitch-primary\\/10{
  --tw-ring-color: rgb(var(--stitch-primary) / 0.1);
}
.ring-stitch-ring{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--stitch-ring) / var(--tw-ring-opacity, 1));
}
.ring-white\\/25{
  --tw-ring-color: rgb(255 255 255 / 0.25);
}
.ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl{
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[130px\\]{
  --tw-blur: blur(130px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[color\\2c background-color\\2c border-color\\2c transform\\2c box-shadow\\]{
  transition-property: color,background-color,border-color,transform,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-\\[800ms\\]{
  transition-duration: 800ms;
}
.duration-stitch{
  transition-duration: var(--stitch-duration);
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-stitch-out{
  transition-timing-function: var(--stitch-ease-out);
}
.\\[background-image\\:radial-gradient\\(circle_at_1px_1px\\2c rgb\\(15_23_42\\)_1px\\2c transparent_0\\)\\]{
  background-image: radial-gradient(circle at 1px 1px,rgb(15 23 42) 1px,transparent 0);
}
.\\[background-image\\:radial-gradient\\(circle_at_1px_1px\\2c white_1px\\2c transparent_0\\)\\]{
  background-image: radial-gradient(circle at 1px 1px,white 1px,transparent 0);
}
.\\[background-image\\:url\\(\\'https\\:\\/\\/www\\.transparenttextures\\.com\\/patterns\\/cubes\\.png\\'\\)\\]{
  background-image: url('https://www.transparenttextures.com/patterns/cubes.png');
}
.\\[background-size\\:18px_18px\\]{
  background-size: 18px 18px;
}
.\\[background-size\\:22px_22px\\]{
  background-size: 22px 22px;
}
.\\[contain\\:layout_paint\\]{
  contain: layout paint;
}
.\\[scrollbar-color\\:rgba\\(148\\2c 163\\2c 184\\2c 0\\.6\\)_transparent\\]{
  scrollbar-color: rgba(148,163,184,0.6) transparent;
}
.\\[scrollbar-width\\:thin\\]{
  scrollbar-width: thin;
}
.placeholder\\:text-stitch-muted::placeholder{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-muted) / var(--tw-text-opacity, 1));
}
.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}
.before\\:-inset-2::before{
  content: var(--tw-content);
  inset: -0.5rem;
}
.before\\:content-\\[\\'\\'\\]::before{
  --tw-content: '';
  content: var(--tw-content);
}
.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}
.hover\\:border-stitch-accent\\/20:hover{
  border-color: rgb(var(--stitch-accent) / 0.2);
}
.hover\\:border-stitch-accent\\/40:hover{
  border-color: rgb(var(--stitch-accent) / 0.4);
}
.hover\\:border-stitch-muted:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-muted) / var(--tw-border-opacity, 1));
}
.hover\\:border-stitch-primary:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-primary) / var(--tw-border-opacity, 1));
}
.hover\\:border-stitch-primary\\/20:hover{
  border-color: rgb(var(--stitch-primary) / 0.2);
}
.hover\\:border-stitch-primary\\/25:hover{
  border-color: rgb(var(--stitch-primary) / 0.25);
}
.hover\\:border-stitch-primary\\/30:hover{
  border-color: rgb(var(--stitch-primary) / 0.3);
}
.hover\\:border-stitch-primary\\/40:hover{
  border-color: rgb(var(--stitch-primary) / 0.4);
}
.hover\\:\\!bg-stitch-surface\\/20:hover{
  background-color: rgb(var(--stitch-surface) / 0.2) !important;
}
.hover\\:bg-stitch-accent-hover:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-accent-hover) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-stitch-accent-soft\\/40:hover{
  background-color: rgb(var(--stitch-accent-soft) / 0.4);
}
.hover\\:bg-stitch-accent\\/20:hover{
  background-color: rgb(var(--stitch-accent) / 0.2);
}
.hover\\:bg-stitch-border\\/30:hover{
  background-color: rgb(var(--stitch-border) / 0.3);
}
.hover\\:bg-stitch-border\\/40:hover{
  background-color: rgb(var(--stitch-border) / 0.4);
}
.hover\\:bg-stitch-danger-soft:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-danger-soft) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-stitch-primary-hover:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-primary-hover) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-stitch-primary-hover\\/50:hover{
  background-color: rgb(var(--stitch-primary-hover) / 0.5);
}
.hover\\:bg-stitch-primary-soft:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-primary-soft) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-stitch-primary-soft\\/30:hover{
  background-color: rgb(var(--stitch-primary-soft) / 0.3);
}
.hover\\:bg-stitch-primary-soft\\/40:hover{
  background-color: rgb(var(--stitch-primary-soft) / 0.4);
}
.hover\\:bg-stitch-primary-soft\\/50:hover{
  background-color: rgb(var(--stitch-primary-soft) / 0.5);
}
.hover\\:bg-stitch-surface-2:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-surface-2) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-stitch-surface-2\\/20:hover{
  background-color: rgb(var(--stitch-surface-2) / 0.2);
}
.hover\\:bg-stitch-surface-2\\/80:hover{
  background-color: rgb(var(--stitch-surface-2) / 0.8);
}
.hover\\:bg-stitch-surface\\/20:hover{
  background-color: rgb(var(--stitch-surface) / 0.2);
}
.hover\\:bg-white\\/90:hover{
  background-color: rgb(255 255 255 / 0.9);
}
.hover\\:text-stitch-danger:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-danger) / var(--tw-text-opacity, 1));
}
.hover\\:text-stitch-fg:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-fg) / var(--tw-text-opacity, 1));
}
.hover\\:text-stitch-fg-soft:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-fg-soft) / var(--tw-text-opacity, 1));
}
.hover\\:text-stitch-muted:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-muted) / var(--tw-text-opacity, 1));
}
.hover\\:text-stitch-primary:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-primary) / var(--tw-text-opacity, 1));
}
.hover\\:text-stitch-primary-hover:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-primary-hover) / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-white\\/80:hover{
  color: rgb(255 255 255 / 0.8);
}
.hover\\:underline:hover{
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}
.hover\\:decoration-stitch-primary:hover{
  -webkit-text-decoration-color: rgb(var(--stitch-primary) / 1);
          text-decoration-color: rgb(var(--stitch-primary) / 1);
}
.hover\\:opacity-80:hover{
  opacity: 0.8;
}
.hover\\:opacity-90:hover{
  opacity: 0.9;
}
.hover\\:opacity-95:hover{
  opacity: 0.95;
}
.hover\\:shadow-stitch-pop:hover{
  --tw-shadow: var(--stitch-shadow-pop);
  --tw-shadow-colored: var(--stitch-shadow-pop);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-stitch-primary\\/5:hover{
  --tw-shadow-color: rgb(var(--stitch-primary) / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.focus\\:border-stitch-danger:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-danger) / var(--tw-border-opacity, 1));
}
.focus\\:border-stitch-primary:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-primary) / var(--tw-border-opacity, 1));
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-stitch-accent\\/30:focus{
  --tw-ring-color: rgb(var(--stitch-accent) / 0.3);
}
.focus\\:ring-stitch-danger:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--stitch-danger) / var(--tw-ring-opacity, 1));
}
.focus\\:ring-stitch-primary:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--stitch-primary) / var(--tw-ring-opacity, 1));
}
.focus\\:ring-stitch-primary\\/25:focus{
  --tw-ring-color: rgb(var(--stitch-primary) / 0.25);
}
.focus\\:ring-stitch-primary\\/30:focus{
  --tw-ring-color: rgb(var(--stitch-primary) / 0.3);
}
.focus\\:ring-stitch-ring:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--stitch-ring) / var(--tw-ring-opacity, 1));
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus\\:ring-offset-stitch-canvas:focus{
  --tw-ring-offset-color: rgb(var(--stitch-canvas) / 1);
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-stitch-ring:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--stitch-ring) / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-stitch-canvas:focus-visible{
  --tw-ring-offset-color: rgb(var(--stitch-canvas) / 1);
}
.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.99\\]:active{
  --tw-scale-x: 0.99;
  --tw-scale-y: 0.99;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:bg-stitch-muted:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-muted) / var(--tw-bg-opacity, 1));
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
.group:hover .group-hover\\:scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-stitch-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-primary) / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.group:focus-visible .group-focus-visible\\:ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.group:focus-visible .group-focus-visible\\:ring-stitch-ring{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--stitch-ring) / var(--tw-ring-opacity, 1));
}
.group:focus-visible .group-focus-visible\\:ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.data-\\[closed\\]\\:scale-\\[0\\.98\\][data-closed]{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[closed\\]\\:opacity-0[data-closed]{
  opacity: 0;
}
.group[data-checked] .group-data-\\[checked\\]\\:border-stitch-primary{
  --tw-border-opacity: 1;
  border-color: rgb(var(--stitch-primary) / var(--tw-border-opacity, 1));
}
.group[data-checked] .group-data-\\[checked\\]\\:bg-stitch-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-primary) / var(--tw-bg-opacity, 1));
}
.group[data-checked] .group-data-\\[checked\\]\\:opacity-100{
  opacity: 1;
}
.dark\\:bg-stitch-border\\/50:is(.dark *){
  background-color: rgb(var(--stitch-border) / 0.5);
}
.dark\\:bg-stitch-danger-soft\\/15:is(.dark *){
  background-color: rgb(var(--stitch-danger-soft) / 0.15);
}
.dark\\:bg-stitch-info-soft\\/10:is(.dark *){
  background-color: rgb(var(--stitch-info-soft) / 0.1);
}
.dark\\:bg-stitch-info-soft\\/15:is(.dark *){
  background-color: rgb(var(--stitch-info-soft) / 0.15);
}
.dark\\:bg-stitch-primary-soft\\/20:is(.dark *){
  background-color: rgb(var(--stitch-primary-soft) / 0.2);
}
.dark\\:bg-stitch-success-soft\\/15:is(.dark *){
  background-color: rgb(var(--stitch-success-soft) / 0.15);
}
.dark\\:bg-stitch-success-soft\\/20:is(.dark *){
  background-color: rgb(var(--stitch-success-soft) / 0.2);
}
.dark\\:bg-stitch-surface-2:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-surface-2) / var(--tw-bg-opacity, 1));
}
.dark\\:bg-stitch-surface-2\\/30:is(.dark *){
  background-color: rgb(var(--stitch-surface-2) / 0.3);
}
.dark\\:bg-stitch-surface\\/90:is(.dark *){
  background-color: rgb(var(--stitch-surface) / 0.9);
}
.dark\\:bg-stitch-warning-soft\\/10:is(.dark *){
  background-color: rgb(var(--stitch-warning-soft) / 0.1);
}
.dark\\:bg-stitch-warning-soft\\/15:is(.dark *){
  background-color: rgb(var(--stitch-warning-soft) / 0.15);
}
.dark\\:bg-stitch-warning-soft\\/20:is(.dark *){
  background-color: rgb(var(--stitch-warning-soft) / 0.2);
}
.dark\\:from-stitch-canvas:is(.dark *){
  --tw-gradient-from: rgb(var(--stitch-canvas) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--stitch-canvas) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:via-stitch-canvas:is(.dark *){
  --tw-gradient-to: rgb(var(--stitch-canvas) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--stitch-canvas) / 1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.dark\\:via-white\\/\\[0\\.04\\]:is(.dark *){
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.04) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.dark\\:to-stitch-canvas:is(.dark *){
  --tw-gradient-to: rgb(var(--stitch-canvas) / 1) var(--tw-gradient-to-position);
}
.dark\\:text-stitch-accent:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-accent) / var(--tw-text-opacity, 1));
}
.dark\\:text-stitch-danger:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-danger) / var(--tw-text-opacity, 1));
}
.dark\\:text-stitch-info:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-info) / var(--tw-text-opacity, 1));
}
.dark\\:text-stitch-primary:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-primary) / var(--tw-text-opacity, 1));
}
.dark\\:text-stitch-success:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-success) / var(--tw-text-opacity, 1));
}
.dark\\:text-stitch-warning:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(var(--stitch-warning) / var(--tw-text-opacity, 1));
}
.dark\\:shadow-none:is(.dark *){
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:hover\\:bg-stitch-primary-soft\\/20:hover:is(.dark *){
  background-color: rgb(var(--stitch-primary-soft) / 0.2);
}
.dark\\:hover\\:bg-stitch-surface-2:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(var(--stitch-surface-2) / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-stitch-surface-2\\/80:hover:is(.dark *){
  background-color: rgb(var(--stitch-surface-2) / 0.8);
}
.dark\\:hover\\:bg-stitch-surface-2\\/90:hover:is(.dark *){
  background-color: rgb(var(--stitch-surface-2) / 0.9);
}
@media (min-width: 640px){

  .sm\\:inline{
    display: inline;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-32{
    height: 8rem;
  }

  .sm\\:h-40{
    height: 10rem;
  }

  .sm\\:w-32{
    width: 8rem;
  }

  .sm\\:w-40{
    width: 10rem;
  }

  .sm\\:w-80{
    width: 20rem;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:flex-1{
    flex: 1 1 0%;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-end{
    align-items: flex-end;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-start{
    justify-content: flex-start;
  }

  .sm\\:justify-center{
    justify-content: center;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-3{
    gap: 0.75rem;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-8{
    gap: 2rem;
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--tw-space-x-reverse));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:p-10{
    padding: 2.5rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:py-24{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-24{
    padding-bottom: 6rem;
  }

  .sm\\:pt-16{
    padding-top: 4rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 768px){

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .md\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .md\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:block{
    display: block;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:w-64{
    width: 16rem;
  }

  .md\\:auto-rows-fr{
    grid-auto-rows: minmax(0, 1fr);
  }

  .md\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-end{
    align-items: flex-end;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-start{
    justify-content: flex-start;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:self-auto{
    align-self: auto;
  }

  .md\\:p-10{
    padding: 2.5rem;
  }

  .md\\:p-12{
    padding: 3rem;
  }

  .md\\:p-16{
    padding: 4rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .md\\:py-24{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .md\\:pt-14{
    padding-top: 3.5rem;
  }

  .md\\:text-left{
    text-align: left;
  }

  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-7xl{
    font-size: 4.5rem;
    line-height: 1;
  }

  .md\\:text-8xl{
    font-size: 6rem;
    line-height: 1;
  }

  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1024px){

  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .lg\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .lg\\:ml-6{
    margin-left: 1.5rem;
  }

  .lg\\:mt-0{
    margin-top: 0px;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-auto{
    height: auto;
  }

  .lg\\:min-h-\\[calc\\(100dvh-8rem\\)\\]{
    min-height: calc(100dvh - 8rem);
  }

  .lg\\:min-h-\\[min\\(820px\\2c calc\\(100dvh-7rem\\)\\)\\]{
    min-height: min(820px,calc(100dvh - 7rem));
  }

  .lg\\:flex-1{
    flex: 1 1 0%;
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[1\\.05fr_0\\.95fr\\]{
    grid-template-columns: 1.05fr 0.95fr;
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:items-stretch{
    align-items: stretch;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:gap-8{
    gap: 2rem;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:pb-28{
    padding-bottom: 7rem;
  }

  .lg\\:pt-20{
    padding-top: 5rem;
  }

  .lg\\:text-left{
    text-align: left;
  }
}
@media (min-width: 1280px){

  .xl\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .xl\\:col-span-9{
    grid-column: span 9 / span 9;
  }

  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4EAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;UAAd,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,wCAAc;EAAd,4BAAc;EAAd,4BAAc;EAAd,qBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,wBAAc;UAAd,gBAAc;EAAd,UAAc;EAAd,iCAAc;UAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA,wBAAc;YAAd;EAAc;AAAA;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA,wBAAc;YAAd;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,4BAAc;AAAA;;AAAd;;EAAA;IAAA,wBAAc;YAAd;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,gBAAc;EAAd;AAAc;;AAAd;EAAA,6BAAc;EAAd;AAAc;;AAAd,0CAAc;;AAAd;;;IAAA,sBAAc;EAAA;;AAAd;IAAA,SAAc;IAAd,8EAAc;IAAd,gBAAc;IAAd,kBAAc;IAAd,qEAAc;IAAd,oBAAc;IAAd,wDAAc;IAAd,mCAAc;IAAd,kCAAc;EAAA;;AAAd;;;;;;;IAAc;;AAAd;;IAAA,eAAc;IAAd,gBAAc;EAAA;;AAAd;;;IAAc;;AAAd;;;;;;;;;;;;;;EAAA,sBAAc;EAAd,qEAAc;EAAd,kBAAc;EAAd,sEAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd;;;;;;;;;;;;;;EAAA,oBAAc;EAAd;AAAc;;AAAd;EAAA,kBAAc;EAAd,sEAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd;IAAA,wCAAc;IAAd,mBAAc;IAAd,kBAAc;IAAd,eAAc;IAAd,cAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,qBAAc;IAAd,mBAAc;IAAd,iBAAc;IAAd,cAAc;IAAd,6BAAc;IAAd,qCAAc;IAAd,kCAAc;IAAd,mCAAc;IAAd,kEAAc;IAAd,kCAAc;IAAd,sBAAc;EAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,2BAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,iBAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,4BAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB,8BAAoB;UAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB,8BAAoB;UAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,gCAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,kBAAoB;EAApB,6BAAoB;EAApB,kCAAoB;EAApB,wDAAoB;EAApB,oCAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB,0BAAoB;UAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,aAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,oBAAoB;EAApB,0BAAoB;EAApB,sFAAoB;EAApB,kBAAoB;EAApB,wBAAoB;EAApB,qBAAoB;EAApB,4BAAoB;UAApB,2BAAoB;EAApB,wBAAoB;EAApB,8BAAoB;UAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,wCAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB,uBAAoB;EAApB,wBAAoB;EAApB,gCAAoB;UAApB,+BAAoB;EAApB,2BAAoB;EAApB,kCAAoB;UAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,UAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,sBAAoB;EAApB,gCAAoB;UAApB,+BAAoB;EAApB,2BAAoB;EAApB,kCAAoB;UAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,yBAAoB;EAApB,wBAAoB;EAApB,4BAAoB;EAApB,2BAAoB;EAApB,sBAAoB;EAApB,0BAAoB;EAApB,iCAAoB;EAApB,4BAAoB;EAApB,uBAAoB;EAApB,2CAAoB;EAApB,wBAAoB;EAApB,4BAAoB;EAApB,0BAAoB;EAApB,8BAAoB;EAApB,8BAAoB;EAApB,+BAAoB;EAApB,gCAAoB;EAApB,+BAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,kCAAoB;EAApB,6BAAoB;EAApB,iCAAoB;EAApB,wCAAoB;EAApB,mCAAoB;EAApB,2BAAoB;EAApB,qDAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,0CAAoB;EAApB,qCAAoB;EAApB,qCAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;UAApB;AAAoB;AAApB;EAAA,8BAAoB;UAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,8BAAoB;UAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;UAApB;AAAoB;AAApB;EAAA,sBAAoB;UAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB,gCAAoB;UAApB,+BAAoB;EAApB,2BAAoB;EAApB,kCAAoB;UAApB;AAAoB;AAApB;EAAA,wBAAoB;UAApB;AAAoB;AAApB;EAAA,sBAAoB;UAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,yBAAoB;EAApB;AAAoB;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uFAAmB;EAAnB,mFAAmB;EAAnB;AAAmB;AAAnB;EAAA,qFAAmB;EAAnB,8EAAmB;EAAnB;AAAmB;AAAnB;EAAA,kFAAmB;EAAnB,8EAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,+EAAmB;EAAnB;AAAmB;AAAnB;EAAA,wFAAmB;EAAnB,oFAAmB;EAAnB;AAAmB;AAAnB;EAAA,0FAAmB;EAAnB,oFAAmB;EAAnB;AAAmB;AAAnB;EAAA,sFAAmB;EAAnB,+EAAmB;EAAnB;AAAmB;AAAnB;EAAA,wFAAmB;EAAnB,oFAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,+EAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,+EAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB;AAAmB;AAAnB;EAAA,sFAAmB;EAAnB;AAAmB;AAAnB;EAAA,qFAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uCAAmB;UAAnB;AAAmB;AAAnB;EAAA,kEAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,wKAAmB;EAAnB,wJAAmB;EAAnB,gNAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uGAAmB;EAAnB,+FAAmB;EAAnB,8HAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAJnB;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,0BAiFA;EAjFA;AAiFA;AAjFA;EAAA,0BAiFA;EAjFA;AAiFA;AAjFA;EAAA,gBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,sBAiFA;EAjFA;AAiFA;AAjFA;EAAA,sBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,uCAiFA;UAjFA;AAiFA;AAjFA;EAAA,6DAiFA;UAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,qCAiFA;EAjFA,6CAiFA;EAjFA;AAiFA;AAjFA;EAAA,gFAiFA;EAjFA,oGAiFA;EAjFA;AAiFA;AAjFA;EAAA,oDAiFA;EAjFA;AAiFA;AAjFA;EAAA,sBAiFA;EAjFA;AAiFA;AAjFA;EAAA,sBAiFA;EAjFA;AAiFA;AAjFA;EAAA,8BAiFA;EAjFA;AAiFA;AAjFA;EAAA,2GAiFA;EAjFA,yGAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,8BAiFA;EAjFA;AAiFA;AAjFA;EAAA,2GAiFA;EAjFA,yGAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,iBAiFA;EAjFA,iBAiFA;EAjFA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,2GAiFA;EAjFA,yGAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,sBAiFA;EAjFA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,kFAiFA;EAjFA,8EAiFA;EAjFA;AAiFA;AAjFA;EAAA,+EAiFA;EAjFA;AAiFA;AAjFA;EAAA,sEAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,oBAiFA;EAjFA;AAiFA;AAjFA;EAAA,sBAiFA;EAjFA,8BAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA,kBAiFA;EAjFA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;EAAA;AAiFA;AAjFA;;EAAA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA,uBAiFA;IAjFA,oDAiFA;IAjFA;EAiFA;;EAjFA;IAAA,uBAiFA;IAjFA,sDAiFA;IAjFA;EAiFA;;EAjFA;IAAA,uBAiFA;IAjFA,2DAiFA;IAjFA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA,oBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,kBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,oBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,kBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,iBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,iBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,iBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,iBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,iBAiFA;IAjFA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA,mBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,kBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,eAiFA;IAjFA;EAiFA;;EAjFA;IAAA,mBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,mBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,kBAiFA;IAjFA;EAiFA;AAAA;AAjFA;;EAAA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA,gBAiFA;IAjFA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA,iBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,iBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,iBAiFA;IAjFA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA,iBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,mBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,kBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,eAiFA;IAjFA;EAiFA;;EAjFA;IAAA,kBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,iBAiFA;IAjFA;EAiFA;;EAjFA;IAAA,eAiFA;IAjFA;EAiFA;;EAjFA;IAAA,kBAiFA;IAjFA;EAiFA;AAAA;AAjFA;;EAAA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA,kBAiFA;IAjFA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;AAAA;AAjFA;;EAAA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;;EAjFA;IAAA;EAiFA;AAAA","sourcesContent":["@import './styles/stitch-tokens.css';\r\n\r\n@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n@layer base {\r\n  /* Basic resets for consistent rendering */\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  body {\r\n    margin: 0;\r\n    font-family: Inter, system-ui, 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    line-height: 1.5;\r\n    @apply bg-stitch-canvas text-stitch-fg antialiased;\r\n  }\r\n\r\n  /*\r\n   * Mobile overflow safety net. On real phones (e.g. Galaxy S23 @ 360px) any single\r\n   * stray-wide descendant — a decorative blur blob, a long unbreakable string — makes\r\n   * <body> wider than the viewport, which shifts the whole page right (logo padding\r\n   * scrolls off, right edge gets cut). `clip` stops that horizontal shift without\r\n   * turning <body> into a scroll container, so `position: sticky` on the header keeps\r\n   * working. This is a guard, not a licence to ship genuinely-wide content.\r\n   */\r\n  html,\r\n  body {\r\n    max-width: 100%;\r\n    overflow-x: clip;\r\n  }\r\n\r\n  /*\r\n   * Safety net: @tailwindcss/forms defaults raw inputs to white backgrounds.\r\n   * Without this, dark mode shows invisible text on white fields.\r\n   */\r\n  html.dark input[type='text'],\r\n  html.dark input[type='email'],\r\n  html.dark input[type='password'],\r\n  html.dark input[type='search'],\r\n  html.dark input[type='tel'],\r\n  html.dark input[type='url'],\r\n  html.dark input[type='number'],\r\n  html.dark input[type='date'],\r\n  html.dark input[type='time'],\r\n  html.dark input[type='datetime-local'],\r\n  html.dark input[type='month'],\r\n  html.dark input[type='week'],\r\n  html.dark textarea,\r\n  html.dark select {\r\n    @apply border-stitch-border bg-stitch-surface text-stitch-fg placeholder:text-stitch-muted;\r\n  }\r\n\r\n  html.dark select option {\r\n    @apply bg-stitch-surface text-stitch-fg;\r\n  }\r\n\r\n  .material-symbols-outlined {\r\n    font-family: 'Material Symbols Outlined';\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-size: 24px;\r\n    line-height: 1;\r\n    letter-spacing: normal;\r\n    text-transform: none;\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    word-wrap: normal;\r\n    direction: ltr;\r\n    font-feature-settings: 'liga';\r\n    -webkit-font-feature-settings: 'liga';\r\n    -moz-font-feature-settings: 'liga';\r\n    -webkit-font-smoothing: antialiased;\r\n    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;\r\n    text-rendering: optimizeLegibility;\r\n    vertical-align: middle;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
